<template>
  <div>
    <!-- <vs-alert icon-pack="feather" icon="icon-alert-circle" :active="paymentFormError && (paymentForm.reglement !== 2 || editCardInfos)" color="danger" class="pl-2 mb-4">
      Le formulaire ci-dessous contient des erreur, l'enregistrement n'a pas été effectué.
    </vs-alert> -->

    <vs-card class="p-4" id="paymentForm">
      <div class="flex justify-start align-center">
        <div class="p-4 inline-flex rounded-full feather-icon select-none relative mb-3 bg-light mr-3">
          <feather-icon class="select-none" icon="CreditCardIcon" svgClasses="text-primary stroke-current h-6 w-6" />
        </div>
        <div>
          <h4 class="text-2xl text-dark mb-1">Mode de paiement</h4>
          <h6 class="text-sm text-muted">Choisissez votre mode de paiement</h6>
        </div>
      </div>
      <vs-divider/>

      <div class="flex justify-start align-center" @click="editCardInfos = false">
        <vs-radio color="success" class="mr-6" v-model="paymentForm.reglement" vs-name="prelevement" :vs-value="1"><span class="text-sm">Prélèvement</span></vs-radio>
        <!-- :disabled="true" -->
        <vs-radio color="success" v-model="paymentForm.reglement" vs-name="cb" :vs-value="2"><span class="text-sm">Carte bancaire</span></vs-radio>
      </div>
      <vs-divider/>
      <section v-if="paymentForm.reglement === 2">


        <!-- Simple lecture -->
        <template v-if="!editCardInfos">
          <p class="text-lg mt-8">Type de carte: <strong v-if="paymentForm.typecarte">{{ typecarteOptions[paymentForm.typecarte].label }}</strong></p>
          <p class="text-lg my-4">{{ paymentForm.nocarte }}</p>
          <p class="text-lg my-4">Expire : <strong>{{ paymentForm.expiration }}</strong></p>
        </template>


        <!-- Edition -->
        <template v-if="editCardInfos">
          <div class="mt-6 mb-4">
            <label for="typecarte" class="block">Type de carte</label>
            <select name="typecarte" v-model="paymentForm.typecarte" class="w-full">
              <option v-for="option in typecarteOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                :danger="isInvalid(paymentForm.nocarte, 'cb')"
                danger-text="Vous devez saisir un numéro de cb valide"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                class="w-full"
                icon-pack="feather"
                icon="icon-credit-card"
                label="Numéro de carte" v-model="paymentForm.nocarte" />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-1/2">
              <label for="expiration">Expire : Mois</label>
              <select name="expiration" v-model="cbExpireMonth" class="w-full">
                <option v-for="option in expirationOptions" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div class="vx-col w-1/2">
              <label for="expireYear">Expire: Année</label>
              <select name="expireYear" v-model="cbExpireYear" class="w-full">
                <option v-for="option in expireYearOptions" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
          </div>

          <vs-input
            :danger="isInvalid(paymentForm.cryptogramme, 'cryptogramme')"
            danger-text="Vous devez saisir un cryptogramme valide"
            val-icon-danger="icon-x"
            val-icon-pack="feather"
            class="w-full"
            icon-pack="feather"
            icon="icon-lock"
            label="cryptogramme"
            v-model="paymentForm.cryptogramme" />
        </template>
      </section>

      <section v-else>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input
              :danger="isInvalid(paymentForm.iban, 'iban')"
              danger-text="Vous devez saisir un numéro IBAN valide"
              val-icon-danger="icon-x"
              val-icon-pack="feather"
              class="w-full"
              label="IBAN"
              v-model="paymentForm.iban" />
          </div>
        </div>
        <div class="flex justify-start align-center">
          <vs-input
            :danger="isInvalid(paymentForm.bic, 'bic')"
            danger-text="Vous devez saisir un numéro BIC valide"
            val-icon-danger="icon-x"
            val-icon-pack="feather"
            class="w-full"
            label="BIC"
            v-model="paymentForm.bic" />
        </div>
      </section>

      <div slot="footer">
        <vs-row vs-justify="flex-end" class="pb-10">
          <vs-button v-if="paymentForm.reglement !== 2 || (paymentForm.reglement === 2 && editCardInfos)" :disabled="paymentFormError" @click="onUpdatePaymentInfos()" type="border" color="primary" icon-pack="feather" icon="icon-save">
            Enregistrer
          </vs-button>
          <vs-button v-if="paymentForm.reglement === 2 && !editCardInfos" @click="editCardInfos = true" type="border" color="primary" icon-pack="feather" icon="icon-edit">
            Editer
          </vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'
import { formValidationMixins } from '@/mixins/formValidationMixins.js'

export default {
  name: 'UserPaymentForm',
  mixins: [formValidationMixins],
  data () {
    return {
      editCardInfos: false,
      cbExpireMonth: '',
      cbExpireYear: '',
      paymentForm: {
        reglement: 'cb',
        typecarte: 'Mastercard',
        nocarte: '',
        expiration: '01',
        iban: '',
        bic: '',
        cryptogramme: ''
      },
      typecarteOptions: [
        { label: 'Choisissez...', value: null },
        { label: 'Mastercard', value: 1 },
        { label: 'Visa', value: 2 }
      ],
      expirationOptions: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      expireYearOptions: ['20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
    }
  },
  computed: {
    ...mapState({
      paymentLoading: state => state.user.paymentLoading,
      activeUser: state => state.user.activeUser,
      paymentInfos: state => state.user.paymentInfos,
      paymentFormError () {
        if (this.paymentForm.reglement === 2) {
          return (
            this.isInvalid(this.paymentForm.nocarte, 'cb') ||
            this.isInvalid(this.paymentForm.cryptogramme, 'cryptogramme')
          )
        } else {
          return (
            this.isInvalid(this.paymentForm.iban, 'iban') ||
            this.isInvalid(this.paymentForm.bic, 'bic')
          )
        }
      }
    })
  },
  created () {
    this.refreshUserPaymentInfos()
  },
  methods: {
    ...mapActions('user', ['getPaymentInfos', 'updatePaymentInfos']),
    refreshUserPaymentInfos () {
      this.getPaymentInfos(this.activeUser.id).then(() => {
        this.paymentForm = _.cloneDeep(this.paymentInfos)
      })
    },
    onUpdatePaymentInfos () {
      if (!this.paymentFormError) {
        if (this.paymentForm.reglement === 2) {
          this.updatePaymentInfos({
            id: this.paymentForm.id,
            reglement: this.paymentForm.reglement,
            typecarte: this.paymentForm.typecarte,
            nocarte: this.paymentForm.nocarte,
            expiration: this.paymentForm.expiration,
            cryptogramme: this.paymentForm.cryptogramme
          }).then(() => {
            this.editCardInfos = false
          })
        } else {
          this.updatePaymentInfos({
            id: this.paymentForm.id,
            reglement: this.paymentForm.reglement,
            iban: this.paymentForm.iban,
            bic: this.paymentForm.bic
          }).then(() => {
            this.editCardInfos = false
          })
        }
      }
    }
  },
  watch: {
    cbExpireMonth (val) {
      this.paymentForm.expiration = `${val}-${this.cbExpireYear}`
    },
    cbExpireYear (val) {
      this.paymentForm.expiration = `${this.cbExpireMonth}-${val}`
    }
  }
}
</script>
